import computeBeneficiaryPayload from '@Application/Beneficiaries/Beneficiaries/Actions/computeBeneficiaryPayload';
import type { Computed } from '@Domain/Computed';
import type PlainDate from '@Domain/PlainDate';

export type BeneficiaryStatusPayload = { readonly value: string; readonly label: string };

export type BeneficiaryListItemPayload = {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly birthName: string | null;
	readonly birthDate: string | null;
	readonly homeAddress: string | null;
	readonly phoneNumber: string | null;
	readonly status: BeneficiaryStatusPayload;
	readonly archivedAt: string | null;
	readonly purgeScheduledAt: string | null;
	readonly facility: { readonly id: number };
	readonly assignedUsers: { readonly id: number }[];
	readonly interviewsCount: number;
	readonly documentsCount: number;
};

export type ComputedBeneficiaryListItemPayload = Computed<
	BeneficiaryListItemPayload,
	{
		birthDate: PlainDate | null;
		archivedAt: Date | null;
		purgeScheduledAt: Date | null;
	}
>;

export type BeneficiariesFetchedPayload = {
	totalRecords: number;
	results: BeneficiaryListItemPayload[];
};

export type ComputedBeneficiariesFetchedPayload = Computed<
	BeneficiariesFetchedPayload,
	{
		results: ComputedBeneficiaryListItemPayload[];
	}
>;

export type BeneficiariesFetchedAction = {
	type: 'BENEFICIARIES_FETCHED';
	payload: ComputedBeneficiariesFetchedPayload;
	accountId: number;
	queryKey: string;
};

const computePayload = (payload: BeneficiariesFetchedPayload): ComputedBeneficiariesFetchedPayload => ({
	...payload,
	results: payload.results.map(computeBeneficiaryPayload),
});

export default (
	payload: BeneficiariesFetchedPayload,
	accountId: number,
	queryKey: string,
): BeneficiariesFetchedAction => ({
	type: 'BENEFICIARIES_FETCHED',
	payload: computePayload(payload),
	accountId,
	queryKey,
});
